import React,{Component} from 'react';
import "./style.less";
import {NavBar,Toast,ListView,Icon,Modal} from "antd-mobile";
import {connect} from "react-redux";
import {getshuntList,shuntFakeConverse} from "../../../service/homeService";
let pageIndex = 1;
let pageSize = 10;
const dataError = require('../../../common/image/wrongData.png');
const noOrder = require('../../../common/image//noOrder.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class ShuntOrderList extends Component{
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            showModal:false,
            OrderListData:[],
            dataSource,
            isLoading: true,
            notDataLoading:0,
            orderId:'',
        }
    };
    componentDidMount() {
        pageIndex = 1;
        let params={
            token: this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum: 1
            }
        };
       this._getOrderList(params);
    }
    _getOrderList(params){
        getshuntList(params).then((res) => {
                if(res.data.code == "0000"){
                    console.log(res)
                    if (res.data.data.list.length > 0) {
                        this._setDataSource(res.data.data);
                        // this.setState({data:res.data.data.list})
                    }else{
                        this.setState({isLoading: false,notDataLoading:1});
                    }
                }else {
                    this.setState({notDataLoading:2,isLoading: false});
                    Toast.info(res.data.msg,3)
                }
            }).catch(function (error) {
            console.log(error);
        });
    };
     //数据拼接
     _setDataSource(data) {
        const allData = [...this.state.OrderListData, ...data.list];
        this.setState({
            dataSource:this.state.dataSource.cloneWithRows(allData),
            OrderListData: allData,
        });
        if (pageIndex * pageSize >= data.total) {
            this.setState({isLoading: false});
        }
    }
    //上拉加载
    _onEndReached = () => {
        if (this.state.isLoading) {
            let params = {
                token: this.props.userInfo.token,
                data:{
                    pageSize: pageSize,
                    pageNum: ++pageIndex
                },
            };
            this._getOrderList(params);
        }
    };
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noData">
                        <img src={noOrder} />
                        <p>暂无代下单记录</p>
                    </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noData">
                <img src={dataError} />
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
    callPhone =(id)=>{
        this.setState({
            showModal:true,
            orderId:id
        })
        
    }
    number=(id)=>{ 
        let params = {
            token: this.props.userInfo.token,
            "data": {
                "id": id,
                orderSource:6,
            }
        };
        shuntFakeConverse(params).then((res) => {
            console.log(res)
            if (res.data.code === '0000') {
                window.location.href = "tel://" +  res.data.data.middleNumber;
            }
            else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }
            else {
                Toast.info(res.data.msg);
            }
        }).catch(function (error) {
            console.log(error);
        });
    }
    render(){
        const _renderRow = (i, index, rowID) => (
            <div className="list" key={rowID}>
                <div className="top">
                    <span>订单号  {i.orderNum}</span>
                </div>
                <div className="middle">
                    <div className="location">
                    <div className="line">
                        <div>
                            <span>{i.shiftName}</span>
                            <p>行程时间：{i.shiftTime}</p>
                        </div>
                        {
                            i.status == 54 || i.status == 58 ? null :<div className="phone" onClick={()=>this.callPhone(i.id)}><i className="icon iconfont icondianhuatubiao"></i></div>
                        }
                    </div>
                    <div><i className="icon iconfont icondaixiadanchufadi"></i>{i.startAddress}</div> 
                    <div><i className="icon iconfont icondaixiadanmudedi"></i>{i.endAddress}</div> 
                    <div className="price"><i className="icon iconfont icondaixiadanchufadi" style={{visibility:'hidden'}}></i><span>{i.orderTime}</span><span>￥{i.orderPrice}</span></div>
                </div>
                </div>
            </div>
        )
        return(
            <div className="shuntOrderList">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >分流下单记录</NavBar>
                <div className="content">
                    {this.notData()}
                    {
                        this.state.notDataLoading == 0  ?
                            <ListView
                                ref={el => this.lv = el}
                                dataSource={this.state.dataSource}
                                renderFooter={() => (this.state.isLoading ? <Icon type="loading"/> : '没有更多')}
                                renderRow={_renderRow}
                                style={{
                                    height: '100%',
                                    overflow:'auto'
                                }}
                                onEndReached={this._onEndReached.bind(this)}
                                scrollRenderAheadDistance={300}
                                onEndReachedThreshold={30}
                            />: null
                    }        
                    <Modal
                        className="combineBillViewModal"
                        visible={this.state.showModal}
                        transparent
                        maskClosable={false}
                        footer={[{ text: '否', onPress: () => { this.setState({showModal:!this.state.showModal}); } },{ text: '是', onPress: () => { this.setState({showModal:!this.state.showModal});this.number(this.state.orderId) } }]}
                    >
                        <div className="modalTitle">
                            <div>是否确认拨打电话？</div>
                             {/*    <span>出于隐私保护，该号码为虚拟号码</span> */}
                        </div>
                    </Modal>     
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Member/ShuntOrderList/index.js